import React, { useState } from "react";

import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import TabSelector from "../../../../../Components/Interactive/TabSelector";
import CustomerOrderTransactionTab from "./CustomerOrderTransactionTab";

const MoreOrderDetailsTable = ({ row, orderPaymentData }) => {
  const [value, ] = useState(0);

  return (
    <div>
      <AppBar className="orders-widget-header" position="static">
        <Tabs
          value={value}
          aria-label="Customer Details"
          style={{padding: "0 !important"}}
        >
          <Tab label="Transactions" className="tab-header-text" />
        </Tabs>
      </AppBar>
      <TabSelector value={value} index={0}>
        <CustomerOrderTransactionTab row={row}/>
      </TabSelector>
    </div>
  );
};

export default MoreOrderDetailsTable;
